import { useEffect, useLayoutEffect, useRef, useState } from "react";
import Nav from "react-bootstrap/Nav";

const NavLetterTemplates = ({ pages, activeTab, handleTabChange }) => {
  const navRef = useRef(null);
  const measureRef = useRef(null);

  const [compact, setCompact] = useState(false);

  const checkIfTabsFit = () => {
    if (!navRef.current || !measureRef.current) return;

    const availableWidth = navRef.current.getBoundingClientRect().width;

    // This hidden nav always renders the full tab names,
    // so we know exactly how much width the tabs need.
    const requiredWidth = measureRef.current.scrollWidth;

    setCompact(requiredWidth > availableWidth);
  };

  useLayoutEffect(() => {
    checkIfTabsFit();
  }, [pages]);

  useEffect(() => {
    if (!navRef.current) return;

    const resizeObserver = new ResizeObserver(() => {
      checkIfTabsFit();
    });

    resizeObserver.observe(navRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [pages]);

  const renderPageTab = (page, index, isMeasurement = false) => {
    const isLast = index === pages.length - 1;

    return (
      <Nav.Link
        key={page.id}
        className={`new-provider-nav-link-hover-effect nav-link Pad8 tab-ite ${
          isLast ? "apply-after mr-0" : ""
        }`}
        eventKey={isMeasurement ? undefined : page.id}
        onClick={isMeasurement ? undefined : () => handleTabChange(page.id)}
        title={page.name}
        style={{
          whiteSpace: "nowrap",
          flexShrink: 0,
        }}
      >
        <span
          className="d-flex align-items-center justify-content-center"
          style={{
            gap: "5px",
          }}
        >
          {page?.page_icon && (
            <span className="ic ic-15 d-flex align-items-center justify-content-center">
              <img
                src={page.page_icon}
                alt=""
                className="w-100 h-100"
                style={{
                  objectFit: "contain",
                }}
              />
            </span>
          )}

          {!compact || isMeasurement ? <span>{page.name}</span> : null}
        </span>
      </Nav.Link>
    );
  };

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
      }}
    >
      {/* Actual visible tabs */}
      <Nav
        ref={navRef}
        variant="tabs"
        className="justify-content-start"
        style={{
          marginTop: "5px",
          marginBottom: "5px",
          flexWrap: "nowrap",
          width: "100%",
          overflow: "hidden",
        }}
        activeKey={activeTab}
      >
        <Nav.Link
          className="new-provider-nav-link-hover-effect m-0 nav-link Pad8 tab-ite apply-before"
          eventKey="all"
          onClick={() => handleTabChange("all")}
          title="All"
          style={{
            whiteSpace: "nowrap",
            flexShrink: 0,
            maxWidth: "34px",
          }}
        >
          All
        </Nav.Link>

        {pages.map((page, index) => (
          <Nav.Link
            key={page.id}
            className={`new-provider-nav-link-hover-effect nav-link  m-0 Pad8 tab-ite ${
              index === pages.length - 1 ? "apply-after mr-0" : ""
            }`}
            eventKey={page.id}
            onClick={() => handleTabChange(page.id)}
            title={page.name}
            style={{
              whiteSpace: "nowrap",
              // maxWidth: "max-content",
              flex: 1,
              // flex: compact ? "0 0 auto" : undefined,

              // width: compact ? "auto" : undefined,
              // minWidth: compact ? "0" : undefined,
              // maxWidth: compact ? "none" : undefined,

              // paddingLeft: compact ? "8px" : undefined,
              // paddingRight: compact ? "8px" : undefined,
            }}
          >
            <span
              className="d-flex align-items-center justify-content-center"
              style={{
                gap: compact ? "0px" : "5px",
              }}
            >
              {page?.page_icon && (
                <span className="ic ic-15 d-flex align-items-center justify-content-center">
                  <img
                    src={page.page_icon}
                    alt=""
                    className="w-100 h-100"
                    style={{
                      objectFit: "contain",
                    }}
                  />
                </span>
              )}

              {!compact && <span>{page.name}</span>}
            </span>
          </Nav.Link>
        ))}
      </Nav>

      {/* 
        Hidden full-size version.
        This is ONLY used to calculate whether all names fit.
      */}
      <Nav
        ref={measureRef}
        variant="tabs"
        className="justify-content-around"
        aria-hidden="true"
        style={{
          position: "absolute",
          visibility: "hidden",
          pointerEvents: "none",
          top: 0,
          left: 0,
          width: "max-content",
          flexWrap: "nowrap",
          whiteSpace: "nowrap",
        }}
      >
        <Nav.Link
          className="new-provider-nav-link-hover-effect nav-link Pad8 tab-ite apply-before"
          style={{
            whiteSpace: "nowrap",
            flexShrink: 0,
          }}
        >
          All
        </Nav.Link>

        {pages.map((page, index) => renderPageTab(page, index, true))}
      </Nav>
    </div>
  );
};

export default NavLetterTemplates;
